import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ConfigService } from 'src/app/services/config.service';
import { ApplianceGroup, DataRefsByKey } from '../../../../../shared/models/dataref.model';
import { PackLite } from '../../../../../shared/models/generic/pack-lite.model';
import { ArchivesService } from '../../../../../services/archives/archives.service';
import { ArchiveLite } from '../../../../../shared/models/generic/archive-lite.model';
import { NotificationManagerService } from '../../../../../shared/services/notification-manager.service';

@Component({
  selector: 'app-pack-generate-archive-form',
  templateUrl: './pack-generate-archive-form.component.html',
  styleUrls: ['./pack-generate-archive-form.component.scss'],
  standalone: false,
})
export class PackGenerateArchiveFormComponent {
  @Input() pack: PackLite = {} as PackLite;
  availableApplianceGroups: DataRefsByKey<ApplianceGroup> = {};

  readonly formGroupGenerate: UntypedFormGroup = this.formBuilder.group({
    applianceGroup: [undefined, Validators.required],
  });

  @Input() set applianceGroupsRefData(applianceGroupsRefData: DataRefsByKey<ApplianceGroup> | null) {
    if (applianceGroupsRefData) {
      // calculate appliance groupe for archives
      this.configService.getArchivesTargetAppGroups().subscribe((data) => {
        this.eligibleApplianceGroups = Object.keys(applianceGroupsRefData)
          .filter(
            (key) => data.targetAppGroups && data.targetAppGroups[this.pack.domain] && data.targetAppGroups[this.pack.domain].includes(key),
          )
          .map((applianceGroupKey: string) => ({
            key: applianceGroupKey,
            label: applianceGroupsRefData[applianceGroupKey]?.translatedName ?? applianceGroupKey,
          }));
        if (this.eligibleApplianceGroups.length === 1) {
          this.formGroupGenerate.patchValue({
            applianceGroup: this.eligibleApplianceGroups[0].key,
          });
        }
        if (this.eligibleApplianceGroups.length < 1) {
          this.displayArchivesPanel$.emit(false);
        } else {
          this.displayArchivesPanel$.emit(true);
        }
      });
    }
  }
  @Output() newArchiveHasBeenGenerated$: EventEmitter<void> = new EventEmitter<void>(true);
  @Output() displayArchivesPanel$: EventEmitter<boolean> = new EventEmitter<boolean>(true);

  eligibleApplianceGroups?: { key: string; label: string }[];
  generateFormErrorMessage = '';

  constructor(
    private readonly archivesService: ArchivesService,
    private readonly configService: ConfigService,
    private readonly notificationManagerService: NotificationManagerService,
    private formBuilder: UntypedFormBuilder,
  ) {}

  shouldDisableGeneration(): boolean {
    this.generateFormErrorMessage = '';

    if (!this.pack) {
      return true;
    }
    if (!this.eligibleApplianceGroups?.length || this.formGroupGenerate.invalid) {
      this.generateFormErrorMessage = 'BINARIES.MSG.ERROR.APPLIANCE_GROUPE_PACK';
      return true;
    }

    return false;
  }

  generate(): void {
    if (this.shouldDisableGeneration()) {
      return undefined;
    }
    this.archivesService
      .generateForPack({
        packId: this.pack.key,
        ...this.formGroupGenerate.value,
      })
      .subscribe(
        (res: ArchiveLite) => {
          this.newArchiveHasBeenGenerated$.emit();
          this.notificationManagerService.displaySuccess('ARCHIVES.GENERATED');
        },
        (err) => {
          this.notificationManagerService.displayHttpError(err);
        },
      );
  }
}
